import React from "react";
import { makeStyles, Text, mergeClasses } from "@fluentui/react-components";
import { formatDateTime } from "../../utils/Helpers";
import { themeTokens, useGlobalStyles } from "../../utils/Theming";

const useStyles = makeStyles({
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  subject: {
    marginTop: "4px",
    marginBottom: "4px",
  },
  type: {
    color: themeTokens.colorNeutralForeground2,
  },
  notemaker: {
    color: themeTokens.colorNeutralForeground2,
    marginBottom: "8px",
  },
  description: {
    marginTop: "4px",
    marginBottom: themeTokens.spacingVerticalMNudge,
  },
  column: {
    maxWidth: "50%",
    display: "block",
  },
});

const NoteItem = ({ note }) => {
  const styles = useStyles();
  const globalStyles = useGlobalStyles();

  return (
    <div>
      <div className={styles.header}>
        <div className={styles.column}>
          <Text className={mergeClasses(styles.type, globalStyles.truncateText)} size={200} block>
            {note.pvar5}
          </Text>
        </div>
        <div>
          <Text size={200}>{formatDateTime(note.dt)}</Text>
        </div>
      </div>

      <Text className={mergeClasses(styles.subject, globalStyles.truncateText)} weight="bold" block>
        {note.subject}
      </Text>

      <Text className={styles.notemaker} block>
        {note.from}
      </Text>

      <Text className={styles.description} block>
        {note.text}
      </Text>
    </div>
  );
};

export default NoteItem;
